var _rect, _g, _rect2, _rect3, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpsellIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#E95832"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#upsell_icon_svg__clip0_11353_24748)",
    stroke: "#fff",
    strokeWidth: 3.265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 17.5h-14a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-14a2 2 0 00-2-2zM16.5 23.5h18M29.5 15.5v4M21.5 15.5v4"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.56,
    y: 28.56,
    width: 26.88,
    height: 26.88,
    rx: 13.44,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.56,
    y: 28.56,
    width: 26.88,
    height: 26.88,
    rx: 13.44,
    stroke: "#059669",
    strokeWidth: 1.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 34.8a4.2 4.2 0 00-4.2 4.2c0 .535.105 1.044.287 1.514L37.7 44.4a2.41 2.41 0 00-2.4 2.4 2.41 2.41 0 002.4 2.4 2.41 2.41 0 002.4-2.4l3.886-3.886c.47.182.98.286 1.514.286a4.2 4.2 0 004.2-4.2c0-.535-.104-1.044-.286-1.514L47.3 39.6h-2.4v-2.4l2.114-2.114A4.188 4.188 0 0045.5 34.8zm-7.8 10.8c.67 0 1.2.53 1.2 1.2 0 .67-.53 1.2-1.2 1.2-.67 0-1.2-.53-1.2-1.2 0-.67.53-1.2 1.2-1.2z",
    fill: "#059669"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "upsell_icon_svg__clip0_11353_24748"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(13.5 13.5)",
    d: "M0 0h24v24H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/upsell_icon.19ca79ca.svg";
export { SvgUpsellIcon as ReactComponent };